export const PLAY_COMMUNITIES_FEATURE_TOKEN = 'play-in-communities';
